var _asyncToGenerator = require("/build/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _toConsumableArray = require("/build/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _slicedToArray = require("/build/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _regeneratorRuntime = require("/build/node_modules/@babel/runtime/regenerator/index.js");
var _inherits = require("/build/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/build/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/build/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _wrapNativeSuper = require("/build/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
var _classCallCheck = require("/build/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/build/node_modules/@babel/runtime/helpers/createClass.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var perf = typeof performance === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
var hasAbortController = typeof AbortController === 'function';

// minimal backwards-compatibility polyfill
// this doesn't have nearly all the checks and whatnot that
// actual AbortController/Signal has, but it's enough for
// our purposes, and if used properly, behaves the same.
var AC = hasAbortController ? AbortController : /*#__PURE__*/function () {
  "use strict";

  function AbortController() {
    _classCallCheck(this, AbortController);
    this.signal = new AS();
  }
  _createClass(AbortController, [{
    key: "abort",
    value: function abort() {
      this.signal.dispatchEvent('abort');
    }
  }]);
  return AbortController;
}();
var hasAbortSignal = typeof AbortSignal === 'function';
// Some polyfills put this on the AC class, not global
var hasACAbortSignal = typeof AC.AbortSignal === 'function';
var AS = hasAbortSignal ? AbortSignal : hasACAbortSignal ? AC.AbortController : /*#__PURE__*/function () {
  "use strict";

  function AbortSignal() {
    _classCallCheck(this, AbortSignal);
    this.aborted = false;
    this._listeners = [];
  }
  _createClass(AbortSignal, [{
    key: "dispatchEvent",
    value: function dispatchEvent(type) {
      if (type === 'abort') {
        this.aborted = true;
        var e = {
          type: type,
          target: this
        };
        this.onabort(e);
        this._listeners.forEach(function (f) {
          return f(e);
        }, this);
      }
    }
  }, {
    key: "onabort",
    value: function onabort() {}
  }, {
    key: "addEventListener",
    value: function addEventListener(ev, fn) {
      if (ev === 'abort') {
        this._listeners.push(fn);
      }
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(ev, fn) {
      if (ev === 'abort') {
        this._listeners = this._listeners.filter(function (f) {
          return f !== fn;
        });
      }
    }
  }]);
  return AbortSignal;
}();
var warned = new Set();
var deprecatedOption = function deprecatedOption(opt, instead) {
  var code = "LRU_CACHE_OPTION_".concat(opt);
  if (shouldWarn(code)) {
    warn(code, "".concat(opt, " option"), "options.".concat(instead), LRUCache);
  }
};
var deprecatedMethod = function deprecatedMethod(method, instead) {
  var code = "LRU_CACHE_METHOD_".concat(method);
  if (shouldWarn(code)) {
    var prototype = LRUCache.prototype;
    var _Object$getOwnPropert = Object.getOwnPropertyDescriptor(prototype, method),
      get = _Object$getOwnPropert.get;
    warn(code, "".concat(method, " method"), "cache.".concat(instead, "()"), get);
  }
};
var deprecatedProperty = function deprecatedProperty(field, instead) {
  var code = "LRU_CACHE_PROPERTY_".concat(field);
  if (shouldWarn(code)) {
    var prototype = LRUCache.prototype;
    var _Object$getOwnPropert2 = Object.getOwnPropertyDescriptor(prototype, field),
      get = _Object$getOwnPropert2.get;
    warn(code, "".concat(field, " property"), "cache.".concat(instead), get);
  }
};
var emitWarning = function emitWarning() {
  var _process, _console;
  typeof process === 'object' && process && typeof process.emitWarning === 'function' ? (_process = process).emitWarning.apply(_process, arguments) : (_console = console).error.apply(_console, arguments);
};
var shouldWarn = function shouldWarn(code) {
  return !warned.has(code);
};
var warn = function warn(code, what, instead, fn) {
  warned.add(code);
  var msg = "The ".concat(what, " is deprecated. Please use ").concat(instead, " instead.");
  emitWarning(msg, 'DeprecationWarning', code, fn);
};
var isPosInt = function isPosInt(n) {
  return n && n === Math.floor(n) && n > 0 && isFinite(n);
};

/* istanbul ignore next - This is a little bit ridiculous, tbh.
 * The maximum array length is 2^32-1 or thereabouts on most JS impls.
 * And well before that point, you're caching the entire world, I mean,
 * that's ~32GB of just integers for the next/prev links, plus whatever
 * else to hold that many keys and values.  Just filling the memory with
 * zeroes at init time is brutal when you get that big.
 * But why not be complete?
 * Maybe in the future, these limits will have expanded. */
var getUintArray = function getUintArray(max) {
  return !isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? ZeroArray : null;
};
var ZeroArray = /*#__PURE__*/function (_Array) {
  "use strict";

  _inherits(ZeroArray, _Array);
  var _super = _createSuper(ZeroArray);
  function ZeroArray(size) {
    var _this;
    _classCallCheck(this, ZeroArray);
    _this = _super.call(this, size);
    _this.fill(0);
    return _this;
  }
  return _createClass(ZeroArray);
}( /*#__PURE__*/_wrapNativeSuper(Array));
var Stack = /*#__PURE__*/function () {
  "use strict";

  function Stack(max) {
    _classCallCheck(this, Stack);
    if (max === 0) {
      return [];
    }
    var UintArray = getUintArray(max);
    this.heap = new UintArray(max);
    this.length = 0;
  }
  _createClass(Stack, [{
    key: "push",
    value: function push(n) {
      this.heap[this.length++] = n;
    }
  }, {
    key: "pop",
    value: function pop() {
      return this.heap[--this.length];
    }
  }]);
  return Stack;
}();
var LRUCache = /*#__PURE__*/function (_Symbol$iterator) {
  "use strict";

  function LRUCache() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, LRUCache);
    var _options$max = options.max,
      max = _options$max === void 0 ? 0 : _options$max,
      ttl = options.ttl,
      _options$ttlResolutio = options.ttlResolution,
      ttlResolution = _options$ttlResolutio === void 0 ? 1 : _options$ttlResolutio,
      ttlAutopurge = options.ttlAutopurge,
      updateAgeOnGet = options.updateAgeOnGet,
      updateAgeOnHas = options.updateAgeOnHas,
      allowStale = options.allowStale,
      dispose = options.dispose,
      disposeAfter = options.disposeAfter,
      noDisposeOnSet = options.noDisposeOnSet,
      noUpdateTTL = options.noUpdateTTL,
      _options$maxSize = options.maxSize,
      maxSize = _options$maxSize === void 0 ? 0 : _options$maxSize,
      _options$maxEntrySize = options.maxEntrySize,
      maxEntrySize = _options$maxEntrySize === void 0 ? 0 : _options$maxEntrySize,
      sizeCalculation = options.sizeCalculation,
      fetchMethod = options.fetchMethod,
      fetchContext = options.fetchContext,
      noDeleteOnFetchRejection = options.noDeleteOnFetchRejection,
      noDeleteOnStaleGet = options.noDeleteOnStaleGet;

    // deprecated options, don't trigger a warning for getting them if
    // the thing being passed in is another LRUCache we're copying.
    var _ref = options instanceof LRUCache ? {} : options,
      length = _ref.length,
      maxAge = _ref.maxAge,
      stale = _ref.stale;
    if (max !== 0 && !isPosInt(max)) {
      throw new TypeError('max option must be a nonnegative integer');
    }
    var UintArray = max ? getUintArray(max) : Array;
    if (!UintArray) {
      throw new Error('invalid max value: ' + max);
    }
    this.max = max;
    this.maxSize = maxSize;
    this.maxEntrySize = maxEntrySize || this.maxSize;
    this.sizeCalculation = sizeCalculation || length;
    if (this.sizeCalculation) {
      if (!this.maxSize && !this.maxEntrySize) {
        throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
      }
      if (typeof this.sizeCalculation !== 'function') {
        throw new TypeError('sizeCalculation set to non-function');
      }
    }
    this.fetchMethod = fetchMethod || null;
    if (this.fetchMethod && typeof this.fetchMethod !== 'function') {
      throw new TypeError('fetchMethod must be a function if specified');
    }
    this.fetchContext = fetchContext;
    if (!this.fetchMethod && fetchContext !== undefined) {
      throw new TypeError('cannot set fetchContext without fetchMethod');
    }
    this.keyMap = new Map();
    this.keyList = new Array(max).fill(null);
    this.valList = new Array(max).fill(null);
    this.next = new UintArray(max);
    this.prev = new UintArray(max);
    this.head = 0;
    this.tail = 0;
    this.free = new Stack(max);
    this.initialFill = 1;
    this.size = 0;
    if (typeof dispose === 'function') {
      this.dispose = dispose;
    }
    if (typeof disposeAfter === 'function') {
      this.disposeAfter = disposeAfter;
      this.disposed = [];
    } else {
      this.disposeAfter = null;
      this.disposed = null;
    }
    this.noDisposeOnSet = !!noDisposeOnSet;
    this.noUpdateTTL = !!noUpdateTTL;
    this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;

    // NB: maxEntrySize is set to maxSize if it's set
    if (this.maxEntrySize !== 0) {
      if (this.maxSize !== 0) {
        if (!isPosInt(this.maxSize)) {
          throw new TypeError('maxSize must be a positive integer if specified');
        }
      }
      if (!isPosInt(this.maxEntrySize)) {
        throw new TypeError('maxEntrySize must be a positive integer if specified');
      }
      this.initializeSizeTracking();
    }
    this.allowStale = !!allowStale || !!stale;
    this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
    this.updateAgeOnGet = !!updateAgeOnGet;
    this.updateAgeOnHas = !!updateAgeOnHas;
    this.ttlResolution = isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
    this.ttlAutopurge = !!ttlAutopurge;
    this.ttl = ttl || maxAge || 0;
    if (this.ttl) {
      if (!isPosInt(this.ttl)) {
        throw new TypeError('ttl must be a positive integer if specified');
      }
      this.initializeTTLTracking();
    }

    // do not allow completely unbounded caches
    if (this.max === 0 && this.ttl === 0 && this.maxSize === 0) {
      throw new TypeError('At least one of max, maxSize, or ttl is required');
    }
    if (!this.ttlAutopurge && !this.max && !this.maxSize) {
      var code = 'LRU_CACHE_UNBOUNDED';
      if (shouldWarn(code)) {
        warned.add(code);
        var msg = 'TTL caching without ttlAutopurge, max, or maxSize can ' + 'result in unbounded memory consumption.';
        emitWarning(msg, 'UnboundedCacheWarning', code, LRUCache);
      }
    }
    if (stale) {
      deprecatedOption('stale', 'allowStale');
    }
    if (maxAge) {
      deprecatedOption('maxAge', 'ttl');
    }
    if (length) {
      deprecatedOption('length', 'sizeCalculation');
    }
  }
  _createClass(LRUCache, [{
    key: "getRemainingTTL",
    value: function getRemainingTTL(key) {
      return this.has(key, {
        updateAgeOnHas: false
      }) ? Infinity : 0;
    }
  }, {
    key: "initializeTTLTracking",
    value: function initializeTTLTracking() {
      var _this2 = this;
      this.ttls = new ZeroArray(this.max);
      this.starts = new ZeroArray(this.max);
      this.setItemTTL = function (index, ttl) {
        var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : perf.now();
        _this2.starts[index] = ttl !== 0 ? start : 0;
        _this2.ttls[index] = ttl;
        if (ttl !== 0 && _this2.ttlAutopurge) {
          var t = setTimeout(function () {
            if (_this2.isStale(index)) {
              _this2.delete(_this2.keyList[index]);
            }
          }, ttl + 1);
          /* istanbul ignore else - unref() not supported on all platforms */
          if (t.unref) {
            t.unref();
          }
        }
      };
      this.updateItemAge = function (index) {
        _this2.starts[index] = _this2.ttls[index] !== 0 ? perf.now() : 0;
      };

      // debounce calls to perf.now() to 1s so we're not hitting
      // that costly call repeatedly.
      var cachedNow = 0;
      var getNow = function getNow() {
        var n = perf.now();
        if (_this2.ttlResolution > 0) {
          cachedNow = n;
          var t = setTimeout(function () {
            return cachedNow = 0;
          }, _this2.ttlResolution);
          /* istanbul ignore else - not available on all platforms */
          if (t.unref) {
            t.unref();
          }
        }
        return n;
      };
      this.getRemainingTTL = function (key) {
        var index = _this2.keyMap.get(key);
        if (index === undefined) {
          return 0;
        }
        return _this2.ttls[index] === 0 || _this2.starts[index] === 0 ? Infinity : _this2.starts[index] + _this2.ttls[index] - (cachedNow || getNow());
      };
      this.isStale = function (index) {
        return _this2.ttls[index] !== 0 && _this2.starts[index] !== 0 && (cachedNow || getNow()) - _this2.starts[index] > _this2.ttls[index];
      };
    }
  }, {
    key: "updateItemAge",
    value: function updateItemAge(index) {}
  }, {
    key: "setItemTTL",
    value: function setItemTTL(index, ttl, start) {}
  }, {
    key: "isStale",
    value: function isStale(index) {
      return false;
    }
  }, {
    key: "initializeSizeTracking",
    value: function initializeSizeTracking() {
      var _this3 = this;
      this.calculatedSize = 0;
      this.sizes = new ZeroArray(this.max);
      this.removeItemSize = function (index) {
        _this3.calculatedSize -= _this3.sizes[index];
        _this3.sizes[index] = 0;
      };
      this.requireSize = function (k, v, size, sizeCalculation) {
        // provisionally accept background fetches.
        // actual value size will be checked when they return.
        if (_this3.isBackgroundFetch(v)) {
          return 0;
        }
        if (!isPosInt(size)) {
          if (sizeCalculation) {
            if (typeof sizeCalculation !== 'function') {
              throw new TypeError('sizeCalculation must be a function');
            }
            size = sizeCalculation(v, k);
            if (!isPosInt(size)) {
              throw new TypeError('sizeCalculation return invalid (expect positive integer)');
            }
          } else {
            throw new TypeError('invalid size value (must be positive integer)');
          }
        }
        return size;
      };
      this.addItemSize = function (index, size) {
        _this3.sizes[index] = size;
        if (_this3.maxSize) {
          var maxSize = _this3.maxSize - _this3.sizes[index];
          while (_this3.calculatedSize > maxSize) {
            _this3.evict(true);
          }
        }
        _this3.calculatedSize += _this3.sizes[index];
      };
    }
  }, {
    key: "removeItemSize",
    value: function removeItemSize(index) {}
  }, {
    key: "addItemSize",
    value: function addItemSize(index, size) {}
  }, {
    key: "requireSize",
    value: function requireSize(k, v, size, sizeCalculation) {
      if (size || sizeCalculation) {
        throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
      }
    }
  }, {
    key: "indexes",
    value: function indexes() {
      var _this4 = this;
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$allowStale = _ref2.allowStale,
        allowStale = _ref2$allowStale === void 0 ? this.allowStale : _ref2$allowStale;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var i;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this4.size) {
                  _context.next = 15;
                  break;
                }
                i = _this4.tail;
              case 2:
                if (!true) {
                  _context.next = 15;
                  break;
                }
                if (_this4.isValidIndex(i)) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("break", 15);
              case 5:
                if (!(allowStale || !_this4.isStale(i))) {
                  _context.next = 8;
                  break;
                }
                _context.next = 8;
                return i;
              case 8:
                if (!(i === _this4.head)) {
                  _context.next = 12;
                  break;
                }
                return _context.abrupt("break", 15);
              case 12:
                i = _this4.prev[i];
              case 13:
                _context.next = 2;
                break;
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })();
    }
  }, {
    key: "rindexes",
    value: function rindexes() {
      var _this5 = this;
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$allowStale = _ref3.allowStale,
        allowStale = _ref3$allowStale === void 0 ? this.allowStale : _ref3$allowStale;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var i;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this5.size) {
                  _context2.next = 15;
                  break;
                }
                i = _this5.head;
              case 2:
                if (!true) {
                  _context2.next = 15;
                  break;
                }
                if (_this5.isValidIndex(i)) {
                  _context2.next = 5;
                  break;
                }
                return _context2.abrupt("break", 15);
              case 5:
                if (!(allowStale || !_this5.isStale(i))) {
                  _context2.next = 8;
                  break;
                }
                _context2.next = 8;
                return i;
              case 8:
                if (!(i === _this5.tail)) {
                  _context2.next = 12;
                  break;
                }
                return _context2.abrupt("break", 15);
              case 12:
                i = _this5.next[i];
              case 13:
                _context2.next = 2;
                break;
              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })();
    }
  }, {
    key: "isValidIndex",
    value: function isValidIndex(index) {
      return this.keyMap.get(this.keyList[index]) === index;
    }
  }, {
    key: "entries",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function entries() {
      var _iterator, _step, i;
      return _regeneratorRuntime.wrap(function entries$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _iterator = _createForOfIteratorHelper(this.indexes());
              _context3.prev = 1;
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context3.next = 9;
                break;
              }
              i = _step.value;
              _context3.next = 7;
              return [this.keyList[i], this.valList[i]];
            case 7:
              _context3.next = 3;
              break;
            case 9:
              _context3.next = 14;
              break;
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](1);
              _iterator.e(_context3.t0);
            case 14:
              _context3.prev = 14;
              _iterator.f();
              return _context3.finish(14);
            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, entries, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "rentries",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function rentries() {
      var _iterator2, _step2, i;
      return _regeneratorRuntime.wrap(function rentries$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _iterator2 = _createForOfIteratorHelper(this.rindexes());
              _context4.prev = 1;
              _iterator2.s();
            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context4.next = 9;
                break;
              }
              i = _step2.value;
              _context4.next = 7;
              return [this.keyList[i], this.valList[i]];
            case 7:
              _context4.next = 3;
              break;
            case 9:
              _context4.next = 14;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](1);
              _iterator2.e(_context4.t0);
            case 14:
              _context4.prev = 14;
              _iterator2.f();
              return _context4.finish(14);
            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, rentries, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "keys",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function keys() {
      var _iterator3, _step3, i;
      return _regeneratorRuntime.wrap(function keys$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _iterator3 = _createForOfIteratorHelper(this.indexes());
              _context5.prev = 1;
              _iterator3.s();
            case 3:
              if ((_step3 = _iterator3.n()).done) {
                _context5.next = 9;
                break;
              }
              i = _step3.value;
              _context5.next = 7;
              return this.keyList[i];
            case 7:
              _context5.next = 3;
              break;
            case 9:
              _context5.next = 14;
              break;
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](1);
              _iterator3.e(_context5.t0);
            case 14:
              _context5.prev = 14;
              _iterator3.f();
              return _context5.finish(14);
            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, keys, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "rkeys",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function rkeys() {
      var _iterator4, _step4, i;
      return _regeneratorRuntime.wrap(function rkeys$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _iterator4 = _createForOfIteratorHelper(this.rindexes());
              _context6.prev = 1;
              _iterator4.s();
            case 3:
              if ((_step4 = _iterator4.n()).done) {
                _context6.next = 9;
                break;
              }
              i = _step4.value;
              _context6.next = 7;
              return this.keyList[i];
            case 7:
              _context6.next = 3;
              break;
            case 9:
              _context6.next = 14;
              break;
            case 11:
              _context6.prev = 11;
              _context6.t0 = _context6["catch"](1);
              _iterator4.e(_context6.t0);
            case 14:
              _context6.prev = 14;
              _iterator4.f();
              return _context6.finish(14);
            case 17:
            case "end":
              return _context6.stop();
          }
        }
      }, rkeys, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "values",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function values() {
      var _iterator5, _step5, i;
      return _regeneratorRuntime.wrap(function values$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _iterator5 = _createForOfIteratorHelper(this.indexes());
              _context7.prev = 1;
              _iterator5.s();
            case 3:
              if ((_step5 = _iterator5.n()).done) {
                _context7.next = 9;
                break;
              }
              i = _step5.value;
              _context7.next = 7;
              return this.valList[i];
            case 7:
              _context7.next = 3;
              break;
            case 9:
              _context7.next = 14;
              break;
            case 11:
              _context7.prev = 11;
              _context7.t0 = _context7["catch"](1);
              _iterator5.e(_context7.t0);
            case 14:
              _context7.prev = 14;
              _iterator5.f();
              return _context7.finish(14);
            case 17:
            case "end":
              return _context7.stop();
          }
        }
      }, values, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "rvalues",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function rvalues() {
      var _iterator6, _step6, i;
      return _regeneratorRuntime.wrap(function rvalues$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _iterator6 = _createForOfIteratorHelper(this.rindexes());
              _context8.prev = 1;
              _iterator6.s();
            case 3:
              if ((_step6 = _iterator6.n()).done) {
                _context8.next = 9;
                break;
              }
              i = _step6.value;
              _context8.next = 7;
              return this.valList[i];
            case 7:
              _context8.next = 3;
              break;
            case 9:
              _context8.next = 14;
              break;
            case 11:
              _context8.prev = 11;
              _context8.t0 = _context8["catch"](1);
              _iterator6.e(_context8.t0);
            case 14:
              _context8.prev = 14;
              _iterator6.f();
              return _context8.finish(14);
            case 17:
            case "end":
              return _context8.stop();
          }
        }
      }, rvalues, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: _Symbol$iterator,
    value: function value() {
      return this.entries();
    }
  }, {
    key: "find",
    value: function find(fn) {
      var getOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _iterator7 = _createForOfIteratorHelper(this.indexes()),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var i = _step7.value;
          if (fn(this.valList[i], this.keyList[i], this)) {
            return this.get(this.keyList[i], getOptions);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "forEach",
    value: function forEach(fn) {
      var thisp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      var _iterator8 = _createForOfIteratorHelper(this.indexes()),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var i = _step8.value;
          fn.call(thisp, this.valList[i], this.keyList[i], this);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }, {
    key: "rforEach",
    value: function rforEach(fn) {
      var thisp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      var _iterator9 = _createForOfIteratorHelper(this.rindexes()),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var i = _step9.value;
          fn.call(thisp, this.valList[i], this.keyList[i], this);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
  }, {
    key: "prune",
    get: function get() {
      deprecatedMethod('prune', 'purgeStale');
      return this.purgeStale;
    }
  }, {
    key: "purgeStale",
    value: function purgeStale() {
      var deleted = false;
      var _iterator10 = _createForOfIteratorHelper(this.rindexes({
          allowStale: true
        })),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var i = _step10.value;
          if (this.isStale(i)) {
            this.delete(this.keyList[i]);
            deleted = true;
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      return deleted;
    }
  }, {
    key: "dump",
    value: function dump() {
      var arr = [];
      var _iterator11 = _createForOfIteratorHelper(this.indexes({
          allowStale: true
        })),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var i = _step11.value;
          var key = this.keyList[i];
          var v = this.valList[i];
          var value = this.isBackgroundFetch(v) ? v.__staleWhileFetching : v;
          var entry = {
            value: value
          };
          if (this.ttls) {
            entry.ttl = this.ttls[i];
            // always dump the start relative to a portable timestamp
            // it's ok for this to be a bit slow, it's a rare operation.
            var age = perf.now() - this.starts[i];
            entry.start = Math.floor(Date.now() - age);
          }
          if (this.sizes) {
            entry.size = this.sizes[i];
          }
          arr.unshift([key, entry]);
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      return arr;
    }
  }, {
    key: "load",
    value: function load(arr) {
      this.clear();
      var _iterator12 = _createForOfIteratorHelper(arr),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _step12$value = _slicedToArray(_step12.value, 2),
            key = _step12$value[0],
            entry = _step12$value[1];
          if (entry.start) {
            // entry.start is a portable timestamp, but we may be using
            // node's performance.now(), so calculate the offset.
            // it's ok for this to be a bit slow, it's a rare operation.
            var age = Date.now() - entry.start;
            entry.start = perf.now() - age;
          }
          this.set(key, entry.value, entry);
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    }
  }, {
    key: "dispose",
    value: function dispose(v, k, reason) {}
  }, {
    key: "set",
    value: function set(k, v) {
      var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref4$ttl = _ref4.ttl,
        ttl = _ref4$ttl === void 0 ? this.ttl : _ref4$ttl,
        start = _ref4.start,
        _ref4$noDisposeOnSet = _ref4.noDisposeOnSet,
        noDisposeOnSet = _ref4$noDisposeOnSet === void 0 ? this.noDisposeOnSet : _ref4$noDisposeOnSet,
        _ref4$size = _ref4.size,
        size = _ref4$size === void 0 ? 0 : _ref4$size,
        _ref4$sizeCalculation = _ref4.sizeCalculation,
        sizeCalculation = _ref4$sizeCalculation === void 0 ? this.sizeCalculation : _ref4$sizeCalculation,
        _ref4$noUpdateTTL = _ref4.noUpdateTTL,
        noUpdateTTL = _ref4$noUpdateTTL === void 0 ? this.noUpdateTTL : _ref4$noUpdateTTL;
      size = this.requireSize(k, v, size, sizeCalculation);
      // if the item doesn't fit, don't do anything
      // NB: maxEntrySize set to maxSize by default
      if (this.maxEntrySize && size > this.maxEntrySize) {
        // have to delete, in case a background fetch is there already.
        // in non-async cases, this is a no-op
        this.delete(k);
        return this;
      }
      var index = this.size === 0 ? undefined : this.keyMap.get(k);
      if (index === undefined) {
        // addition
        index = this.newIndex();
        this.keyList[index] = k;
        this.valList[index] = v;
        this.keyMap.set(k, index);
        this.next[this.tail] = index;
        this.prev[index] = this.tail;
        this.tail = index;
        this.size++;
        this.addItemSize(index, size);
        noUpdateTTL = false;
      } else {
        // update
        var oldVal = this.valList[index];
        if (v !== oldVal) {
          if (this.isBackgroundFetch(oldVal)) {
            oldVal.__abortController.abort();
          } else {
            if (!noDisposeOnSet) {
              this.dispose(oldVal, k, 'set');
              if (this.disposeAfter) {
                this.disposed.push([oldVal, k, 'set']);
              }
            }
          }
          this.removeItemSize(index);
          this.valList[index] = v;
          this.addItemSize(index, size);
        }
        this.moveToTail(index);
      }
      if (ttl !== 0 && this.ttl === 0 && !this.ttls) {
        this.initializeTTLTracking();
      }
      if (!noUpdateTTL) {
        this.setItemTTL(index, ttl, start);
      }
      if (this.disposeAfter) {
        while (this.disposed.length) {
          this.disposeAfter.apply(this, _toConsumableArray(this.disposed.shift()));
        }
      }
      return this;
    }
  }, {
    key: "newIndex",
    value: function newIndex() {
      if (this.size === 0) {
        return this.tail;
      }
      if (this.size === this.max && this.max !== 0) {
        return this.evict(false);
      }
      if (this.free.length !== 0) {
        return this.free.pop();
      }
      // initial fill, just keep writing down the list
      return this.initialFill++;
    }
  }, {
    key: "pop",
    value: function pop() {
      if (this.size) {
        var val = this.valList[this.head];
        this.evict(true);
        return val;
      }
    }
  }, {
    key: "evict",
    value: function evict(free) {
      var head = this.head;
      var k = this.keyList[head];
      var v = this.valList[head];
      if (this.isBackgroundFetch(v)) {
        v.__abortController.abort();
      } else {
        this.dispose(v, k, 'evict');
        if (this.disposeAfter) {
          this.disposed.push([v, k, 'evict']);
        }
      }
      this.removeItemSize(head);
      // if we aren't about to use the index, then null these out
      if (free) {
        this.keyList[head] = null;
        this.valList[head] = null;
        this.free.push(head);
      }
      this.head = this.next[head];
      this.keyMap.delete(k);
      this.size--;
      return head;
    }
  }, {
    key: "has",
    value: function has(k) {
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref5$updateAgeOnHas = _ref5.updateAgeOnHas,
        updateAgeOnHas = _ref5$updateAgeOnHas === void 0 ? this.updateAgeOnHas : _ref5$updateAgeOnHas;
      var index = this.keyMap.get(k);
      if (index !== undefined) {
        if (!this.isStale(index)) {
          if (updateAgeOnHas) {
            this.updateItemAge(index);
          }
          return true;
        }
      }
      return false;
    }

    // like get(), but without any LRU updating or TTL expiration
  }, {
    key: "peek",
    value: function peek(k) {
      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref6$allowStale = _ref6.allowStale,
        allowStale = _ref6$allowStale === void 0 ? this.allowStale : _ref6$allowStale;
      var index = this.keyMap.get(k);
      if (index !== undefined && (allowStale || !this.isStale(index))) {
        var v = this.valList[index];
        // either stale and allowed, or forcing a refresh of non-stale value
        return this.isBackgroundFetch(v) ? v.__staleWhileFetching : v;
      }
    }
  }, {
    key: "backgroundFetch",
    value: function backgroundFetch(k, index, options, context) {
      var _this6 = this;
      var v = index === undefined ? undefined : this.valList[index];
      if (this.isBackgroundFetch(v)) {
        return v;
      }
      var ac = new AC();
      var fetchOpts = {
        signal: ac.signal,
        options: options,
        context: context
      };
      var cb = function cb(v) {
        if (!ac.signal.aborted) {
          _this6.set(k, v, fetchOpts.options);
        }
        return v;
      };
      var eb = function eb(er) {
        if (_this6.valList[index] === p) {
          var del = !options.noDeleteOnFetchRejection || p.__staleWhileFetching === undefined;
          if (del) {
            _this6.delete(k);
          } else {
            // still replace the *promise* with the stale value,
            // since we are done with the promise at this point.
            _this6.valList[index] = p.__staleWhileFetching;
          }
        }
        if (p.__returned === p) {
          throw er;
        }
      };
      var pcall = function pcall(res) {
        return res(_this6.fetchMethod(k, v, fetchOpts));
      };
      var p = new Promise(pcall).then(cb, eb);
      p.__abortController = ac;
      p.__staleWhileFetching = v;
      p.__returned = null;
      if (index === undefined) {
        this.set(k, p, fetchOpts.options);
        index = this.keyMap.get(k);
      } else {
        this.valList[index] = p;
      }
      return p;
    }
  }, {
    key: "isBackgroundFetch",
    value: function isBackgroundFetch(p) {
      return p && typeof p === 'object' && typeof p.then === 'function' && Object.prototype.hasOwnProperty.call(p, '__staleWhileFetching') && Object.prototype.hasOwnProperty.call(p, '__returned') && (p.__returned === p || p.__returned === null);
    }

    // this takes the union of get() and set() opts, because it does both
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(k) {
        var _ref7,
          _ref7$allowStale,
          allowStale,
          _ref7$updateAgeOnGet,
          updateAgeOnGet,
          _ref7$noDeleteOnStale,
          noDeleteOnStaleGet,
          _ref7$ttl,
          ttl,
          _ref7$noDisposeOnSet,
          noDisposeOnSet,
          _ref7$size,
          size,
          _ref7$sizeCalculation,
          sizeCalculation,
          _ref7$noUpdateTTL,
          noUpdateTTL,
          _ref7$noDeleteOnFetch,
          noDeleteOnFetchRejection,
          _ref7$fetchContext,
          fetchContext,
          _ref7$forceRefresh,
          forceRefresh,
          options,
          index,
          p,
          v,
          _p,
          _args9 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _ref7 = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {}, _ref7$allowStale = _ref7.allowStale, allowStale = _ref7$allowStale === void 0 ? this.allowStale : _ref7$allowStale, _ref7$updateAgeOnGet = _ref7.updateAgeOnGet, updateAgeOnGet = _ref7$updateAgeOnGet === void 0 ? this.updateAgeOnGet : _ref7$updateAgeOnGet, _ref7$noDeleteOnStale = _ref7.noDeleteOnStaleGet, noDeleteOnStaleGet = _ref7$noDeleteOnStale === void 0 ? this.noDeleteOnStaleGet : _ref7$noDeleteOnStale, _ref7$ttl = _ref7.ttl, ttl = _ref7$ttl === void 0 ? this.ttl : _ref7$ttl, _ref7$noDisposeOnSet = _ref7.noDisposeOnSet, noDisposeOnSet = _ref7$noDisposeOnSet === void 0 ? this.noDisposeOnSet : _ref7$noDisposeOnSet, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 0 : _ref7$size, _ref7$sizeCalculation = _ref7.sizeCalculation, sizeCalculation = _ref7$sizeCalculation === void 0 ? this.sizeCalculation : _ref7$sizeCalculation, _ref7$noUpdateTTL = _ref7.noUpdateTTL, noUpdateTTL = _ref7$noUpdateTTL === void 0 ? this.noUpdateTTL : _ref7$noUpdateTTL, _ref7$noDeleteOnFetch = _ref7.noDeleteOnFetchRejection, noDeleteOnFetchRejection = _ref7$noDeleteOnFetch === void 0 ? this.noDeleteOnFetchRejection : _ref7$noDeleteOnFetch, _ref7$fetchContext = _ref7.fetchContext, fetchContext = _ref7$fetchContext === void 0 ? this.fetchContext : _ref7$fetchContext, _ref7$forceRefresh = _ref7.forceRefresh, forceRefresh = _ref7$forceRefresh === void 0 ? false : _ref7$forceRefresh;
                if (this.fetchMethod) {
                  _context9.next = 3;
                  break;
                }
                return _context9.abrupt("return", this.get(k, {
                  allowStale: allowStale,
                  updateAgeOnGet: updateAgeOnGet,
                  noDeleteOnStaleGet: noDeleteOnStaleGet
                }));
              case 3:
                options = {
                  allowStale: allowStale,
                  updateAgeOnGet: updateAgeOnGet,
                  noDeleteOnStaleGet: noDeleteOnStaleGet,
                  ttl: ttl,
                  noDisposeOnSet: noDisposeOnSet,
                  size: size,
                  sizeCalculation: sizeCalculation,
                  noUpdateTTL: noUpdateTTL,
                  noDeleteOnFetchRejection: noDeleteOnFetchRejection
                };
                index = this.keyMap.get(k);
                if (!(index === undefined)) {
                  _context9.next = 10;
                  break;
                }
                p = this.backgroundFetch(k, index, options, fetchContext);
                return _context9.abrupt("return", p.__returned = p);
              case 10:
                // in cache, maybe already fetching
                v = this.valList[index];
                if (!this.isBackgroundFetch(v)) {
                  _context9.next = 13;
                  break;
                }
                return _context9.abrupt("return", allowStale && v.__staleWhileFetching !== undefined ? v.__staleWhileFetching : v.__returned = v);
              case 13:
                if (!(!forceRefresh && !this.isStale(index))) {
                  _context9.next = 17;
                  break;
                }
                this.moveToTail(index);
                if (updateAgeOnGet) {
                  this.updateItemAge(index);
                }
                return _context9.abrupt("return", v);
              case 17:
                // ok, it is stale or a forced refresh, and not already fetching.
                // refresh the cache.
                _p = this.backgroundFetch(k, index, options, fetchContext);
                return _context9.abrupt("return", allowStale && _p.__staleWhileFetching !== undefined ? _p.__staleWhileFetching : _p.__returned = _p);
              case 19:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee3, this);
      }));
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "get",
    value: function get(k) {
      var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref8$allowStale = _ref8.allowStale,
        allowStale = _ref8$allowStale === void 0 ? this.allowStale : _ref8$allowStale,
        _ref8$updateAgeOnGet = _ref8.updateAgeOnGet,
        updateAgeOnGet = _ref8$updateAgeOnGet === void 0 ? this.updateAgeOnGet : _ref8$updateAgeOnGet,
        _ref8$noDeleteOnStale = _ref8.noDeleteOnStaleGet,
        noDeleteOnStaleGet = _ref8$noDeleteOnStale === void 0 ? this.noDeleteOnStaleGet : _ref8$noDeleteOnStale;
      var index = this.keyMap.get(k);
      if (index !== undefined) {
        var value = this.valList[index];
        var fetching = this.isBackgroundFetch(value);
        if (this.isStale(index)) {
          // delete only if not an in-flight background fetch
          if (!fetching) {
            if (!noDeleteOnStaleGet) {
              this.delete(k);
            }
            return allowStale ? value : undefined;
          } else {
            return allowStale ? value.__staleWhileFetching : undefined;
          }
        } else {
          // if we're currently fetching it, we don't actually have it yet
          // it's not stale, which means this isn't a staleWhileRefetching,
          // so we just return undefined
          if (fetching) {
            return undefined;
          }
          this.moveToTail(index);
          if (updateAgeOnGet) {
            this.updateItemAge(index);
          }
          return value;
        }
      }
    }
  }, {
    key: "connect",
    value: function connect(p, n) {
      this.prev[n] = p;
      this.next[p] = n;
    }
  }, {
    key: "moveToTail",
    value: function moveToTail(index) {
      // if tail already, nothing to do
      // if head, move head to next[index]
      // else
      //   move next[prev[index]] to next[index] (head has no prev)
      //   move prev[next[index]] to prev[index]
      // prev[index] = tail
      // next[tail] = index
      // tail = index
      if (index !== this.tail) {
        if (index === this.head) {
          this.head = this.next[index];
        } else {
          this.connect(this.prev[index], this.next[index]);
        }
        this.connect(this.tail, index);
        this.tail = index;
      }
    }
  }, {
    key: "del",
    get: function get() {
      deprecatedMethod('del', 'delete');
      return this.delete;
    }
  }, {
    key: "delete",
    value: function _delete(k) {
      var deleted = false;
      if (this.size !== 0) {
        var index = this.keyMap.get(k);
        if (index !== undefined) {
          deleted = true;
          if (this.size === 1) {
            this.clear();
          } else {
            this.removeItemSize(index);
            var v = this.valList[index];
            if (this.isBackgroundFetch(v)) {
              v.__abortController.abort();
            } else {
              this.dispose(v, k, 'delete');
              if (this.disposeAfter) {
                this.disposed.push([v, k, 'delete']);
              }
            }
            this.keyMap.delete(k);
            this.keyList[index] = null;
            this.valList[index] = null;
            if (index === this.tail) {
              this.tail = this.prev[index];
            } else if (index === this.head) {
              this.head = this.next[index];
            } else {
              this.next[this.prev[index]] = this.next[index];
              this.prev[this.next[index]] = this.prev[index];
            }
            this.size--;
            this.free.push(index);
          }
        }
      }
      if (this.disposed) {
        while (this.disposed.length) {
          this.disposeAfter.apply(this, _toConsumableArray(this.disposed.shift()));
        }
      }
      return deleted;
    }
  }, {
    key: "clear",
    value: function clear() {
      var _iterator13 = _createForOfIteratorHelper(this.rindexes({
          allowStale: true
        })),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var index = _step13.value;
          var v = this.valList[index];
          if (this.isBackgroundFetch(v)) {
            v.__abortController.abort();
          } else {
            var k = this.keyList[index];
            this.dispose(v, k, 'delete');
            if (this.disposeAfter) {
              this.disposed.push([v, k, 'delete']);
            }
          }
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      this.keyMap.clear();
      this.valList.fill(null);
      this.keyList.fill(null);
      if (this.ttls) {
        this.ttls.fill(0);
        this.starts.fill(0);
      }
      if (this.sizes) {
        this.sizes.fill(0);
      }
      this.head = 0;
      this.tail = 0;
      this.initialFill = 1;
      this.free.length = 0;
      this.calculatedSize = 0;
      this.size = 0;
      if (this.disposed) {
        while (this.disposed.length) {
          this.disposeAfter.apply(this, _toConsumableArray(this.disposed.shift()));
        }
      }
    }
  }, {
    key: "reset",
    get: function get() {
      deprecatedMethod('reset', 'clear');
      return this.clear;
    }
  }, {
    key: "length",
    get: function get() {
      deprecatedProperty('length', 'size');
      return this.size;
    }
  }], [{
    key: "AbortController",
    get: function get() {
      return AC;
    }
  }, {
    key: "AbortSignal",
    get: function get() {
      return AS;
    }
  }]);
  return LRUCache;
}(Symbol.iterator);
module.exports = LRUCache;